// extracted by mini-css-extract-plugin
export var pillWrapper = "_qh-0";
export var showOverflow = "_qh-1";